function formatDate(date) {
  if (!date) return ''
  try {
    if (!(date instanceof Date)) date = new Date(date)
    let formatted_date =
      date.getFullYear() == 1
        ? '-'
        : (date.getDate() + '').padStart(2, '0') +
          '/' +
          (date.getMonth() + 1 + '').padStart(2, '0') +
          '/' +
          date.getFullYear()
    return formatted_date
  } catch (error) {
    return date instanceof Date ? date.toLocaleDateString() : ''
  }
}

function formatDateHour(date) {
  if (!date) return ''

  try {
    if (!(date instanceof Date)) date = new Date(date)
    let formatted_date =
      date.getFullYear() == 1
        ? '-'
        : (date.getDate() + '').padStart(2, '0') +
          '/' +
          (date.getMonth() + 1 + '').padStart(2, '0') +
          '/' +
          date.getFullYear() +
          ' à ' +
          (date.getHours() + '').padStart(2, '0') +
          'H' +
          (date.getMinutes() + '').padStart(2, '0') +
          "'"

    return formatted_date
  } catch (error) {
    return date instanceof Date ? date.toLocaleDateString() + ' à ' + date.toLocaleTimeString() : ''
  }
}

function formatDateHourDB(date) {
  try {
    if (!(date instanceof Date)) date = new Date(date)
    let formatted_date =
      date.getFullYear() == 1
        ? '-'
        : (date.getFullYear() + '').padStart(4, '0') +
          '-' +
          (date.getMonth() + 1 + '').padStart(2, '0') +
          '-' +
          (date.getDate() + '').padStart(2, '0') +
          ' ' +
          (date.getHours() + '').padStart(2, '0') +
          ':' +
          (date.getMinutes() + '').padStart(2, '0') +
          ':' +
          (date.getSeconds() + '').padStart(2, '0')
    return formatted_date
  } catch (error) {
    return null
  }
}

function formatDateDB(date) {
  try {
    if (!(date instanceof Date)) date = new Date(date)
    let formatted_date =
      date.getFullYear() == 1
        ? '-'
        : (date.getFullYear() + '').padStart(4, '0') +
          '-' +
          (date.getMonth() + 1 + '').padStart(2, '0') +
          '-' +
          (date.getDate() + '').padStart(2, '0')
    return formatted_date
  } catch (error) {
    return null
  }
}

function getMonthFirstDate(date) {
  try {
    if (!(date instanceof Date)) date = new Date(date)
    return `${(date.getFullYear() + '').padStart(4, '0')}-${(date.getMonth() + 1 + '').padStart(
      2,
      '0',
    )}-01`
  } catch (error) {
    return null
  }
}

function formatHourDB(date) {
  try {
    if (!(date instanceof Date)) date = new Date(date)
    let formatted_date =
      (date.getHours() + '').padStart(2, '0') +
      ':' +
      (date.getMinutes() + '').padStart(2, '0') +
      ':' +
      (date.getSeconds() + '').padStart(2, '0')
    return formatted_date
  } catch (error) {
    return null
  }
}

function formatHour(date) {
  if (!date) return ''
  if (!date) return ''

  try {
    if (!(date instanceof Date)) date = new Date(date)
    let formatted_date =
      date.getFullYear() == 1
        ? '-'
        : (date.getHours() + '').padStart(2, '0') +
          'H' +
          (date.getMinutes() + '').padStart(2, '0') +
          "'"

    return formatted_date
  } catch (error) {
    return null
  }
}

function monthName(month) {
  switch (month) {
    case 1:
      return 'Janvier'
    case 2:
      return 'Février'
    case 3:
      return 'Mars'
    case 4:
      return 'Avril'
    case 5:
      return 'Mai'
    case 6:
      return 'Juin'
    case 7:
      return 'Juillet'
    case 8:
      return 'Août'
    case 9:
      return 'Septembre'
    case 10:
      return 'Octobre'
    case 11:
      return 'Novembre'
    case 12:
      return 'Décembre'
    default:
      return ''
  }
}

function dateMonthName(date) {
  return `${monthName(date.getMonth() + 1)} ${date.getFullYear()}`
}

function dateFullName(date) {
  if (!date) return null
  try {
    if (!(date instanceof Date)) date = new Date(date)
    return `${(date.getDate() + '').padStart(2, '0')} ${monthName(
      date.getMonth() + 1,
    )} ${date.getFullYear()}`
  } catch (error) {
    return null
  }
}

function getDate(date) {
  let d = new Date(date)
  d.setHours(0, 0, 0, 0)

  return d
}

function getYear(date) {
  if (!date) return ''
  if (!(date instanceof Date)) date = new Date(date)
  return date.getFullYear()
}

export default {
  formatDate,
  formatHour,
  formatDateHour,
  formatHourDB,
  formatDateHourDB,
  formatDateDB,
  monthName,
  dateMonthName,
  dateFullName,
  getDate,
  getYear,
  getMonthFirstDate,
}
